import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";
import {
  IGetTicketService,
  INewTicketService,
  IRegisterPhoneNumberRequestData,
  IRequestData,
  IUpdateWebhookRequestData,
} from "../models/tickets-service";
import { IWhatsappProfile } from "../models/whatsapp-profile";
import { IWhatsappName } from "../models/whatsapp-name";

const TICKET_SERVICE_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketServices/";

const TICKET_SERVICE_LIST =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketServiceType/";

export class TicketServService {
  create = (item: INewTicketService) => {
    return GlobalAxios.post(TICKET_SERVICE_ROUTE, item);
  };

  getItemById = (id: string) => {
    return GlobalAxios.get<IGetTicketService>(TICKET_SERVICE_ROUTE + id);
  };

  updateItemById = ({ item, id }: { item: INewTicketService; id: string }) => {
    return GlobalAxios.put(TICKET_SERVICE_ROUTE + id, item);
  };

  list = (params?: any) => {
    return GlobalAxios.get<ISelectType[]>(TICKET_SERVICE_LIST + "list", {
      params: params,
    });
  };

  ticketServiceList = (params?: any) => {
    return GlobalAxios.get<ISelectType[]>(TICKET_SERVICE_ROUTE + "list", {
      params: params,
    });
  };

  listTicketServiceInAreas = (params?: any) => {
    return GlobalAxios.get<ISelectType[]>(
      TICKET_SERVICE_ROUTE + "TicketServiceInArea",
      {
        params: params,
      },
    );
  };
  listTicketServiceInDays = (params?: any) => {
    return GlobalAxios.get<ISelectType[]>(
      TICKET_SERVICE_ROUTE + "listTicketServiceInDays",
      {
        params: params,
      },
    );
  };
  listTicketServiceInMessages = (params?: any) => {
    return GlobalAxios.get<ISelectType[]>(
      TICKET_SERVICE_ROUTE + "listTicketServiceInMessage",
      {
        params: params,
      },
    );
  };
  whatsappRegister = (data: IRequestData) => {
    return GlobalAxios.post<{ id: string }>(
      TICKET_SERVICE_ROUTE + "WhatsappRegister",
      data,
    );
  };
  webhookUpdate = (data: IUpdateWebhookRequestData) => {
    return GlobalAxios.post<{ success: boolean }>(
      TICKET_SERVICE_ROUTE + "UpdateWebhook",
      data,
    );
  };
  registerPhoneNumber = (data: IRegisterPhoneNumberRequestData) => {
    return GlobalAxios.post<{ success: boolean }>(
      TICKET_SERVICE_ROUTE + "RegisterPhoneNumber",
      data,
    );
  };
  getWhatsappBusinesProfile = (params?: any) => {
    return GlobalAxios.get<IWhatsappProfile>(
      TICKET_SERVICE_ROUTE + "WhatsappBusinessProfile",
      {
        params: params,
      },
    );
  };
  updateWhatsappBusinesProfile = (data?: any) => {
    const formData = new FormData();
    formData.append("File", data.file);
    formData.append("Data.About", data.data.about);
    formData.append("Data.Address", data.data.address);
    formData.append("Data.Description", data.data.description);
    formData.append("Data.Email", data.data.email);
    data.data.websites.forEach((el: string) => {
      formData.append("Data.Websites", el);
    });
    formData.append("Data.Vertical", data.data.vertical);
    formData.append("Data.MessagingProduct", data.data.messagingProduct);
    formData.append("Data.ProfilePictureUrl", data.data.profilePictureUrl);
    formData.append("TicketServiceId", data.ticketServiceId);

    return GlobalAxios.post<{ success: boolean }>(
      TICKET_SERVICE_ROUTE + "UpdateWhatsappBusinessProfile",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  };
  getWhatsappName = (params?: any) => {
    return GlobalAxios.get<IWhatsappName>(
      TICKET_SERVICE_ROUTE + "WhatsAppBusinessPhoneNumberInfo",
      {
        params: params,
      },
    );
  };
  updateWhatsappName = (data?: any) => {
    return GlobalAxios.post<{ success: boolean }>(
      TICKET_SERVICE_ROUTE + "UpdateWhatsAppBusinessPhoneNumberInfo",
      data,
    );
  };
}

export default TicketServService;
